import { Component, OnInit  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from "../../components/common/utils/handleError.component";
import { LoginService } from "../login/login.service";
const swal = require("sweetalert2");

@Component({
    selector: 'activacion',
    templateUrl: 'activacion.template.html'
})

export class ActivacionComponent implements OnInit{
    codigoActivacion: string;
    idUser: number;

    constructor(private route: ActivatedRoute, private loginService: LoginService, private router: Router, private handleError: HandleError) { }
    
    ngOnInit(){
        this.codigoActivacion = "";
        this.idUser = 0;
        this.route.params.subscribe(params => {
            this.codigoActivacion = params['codigo'];
            this.idUser = +params['idUser'];
            if (this.codigoActivacion == "" && this.idUser == 0) {
                this.router.navigate(["/error404"]);
            } else {
                this.loginService.activarUsuario(this.codigoActivacion,this.idUser).subscribe(result => {
                    var resultado = result;
                    var varGeneral = this;
                    if(resultado == 3 || resultado == 2 || resultado == 1){
                        swal({
                            title: 'Activación',
                            text: "Usuario activado correctamente, ya puede ingresar al portal de TECNIENLINEA",
                            type: 'success'
                        }).then((function(){
                            var bandera = 0;
                            switch(resultado){
                                case 1:
                                    bandera = 2;
                                break;
                                case 2:
                                case 3:
                                    bandera = 1;
                                break;
                            }
                            varGeneral.router.navigate(["/login",bandera]);
                        }).bind(this));
                    }else{
                        swal({
                            title: 'Lo sentimos',
                            text: "El usuario ya se encuentra activo",
                            type: 'error'
                        }).then((function(){
                            window.location.href = "http://www.tecniseguros.com.ec";
                        }).bind(this));
                    }
                },
                    erorr => {
                        swal({
                            title: 'Lo sentimos',
                            text: "Ha ocurrido un error, por favor intentelo más tarde",
                            type: 'error'
                        }).then((function(){
                            window.location.href = "http://www.tecniseguros.com.ec";
                        }).bind(this));
                    });
            }
        });
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/register/activacion.component.ts